import { useEffect, useState } from "react";
import { getLoggedinUser } from "../../helpers/api_helper";
import { isTokenValid, getAuthUser } from "../../helpers/tokenHelper";

const useProfile = () => {
  const [loading, setLoading] = useState(true);
  const [userProfile, setUserProfile] = useState<any>(null);
  const [token, setToken] = useState<string | null>(null);

    useEffect(() => {
    // Kiểm tra authentication và token expiration khi component mount
    const checkAuth = () => {
      try {
        // Kiểm tra token có hết hạn không
        if (!isTokenValid()) {
          console.log('Token expired or invalid');
          setUserProfile(null);
          setToken(null);
          setLoading(false);
          return;
        }
        
        // Token còn hạn - lấy user data
        const userProfileSession = getLoggedinUser();
        
        if (userProfileSession) {
          const userToken = userProfileSession["token"] || userProfileSession["access_token"];
          
          if (userToken) {
            // User authenticated với token hợp lệ
            setUserProfile(userProfileSession);
            setToken(userToken);
            setLoading(false);
            return;
          }
        }
        
        // No valid auth found
        setUserProfile(null);
        setToken(null);
        setLoading(false);
      } catch (error) {
        console.error('Error checking authentication:', error);
        setUserProfile(null);
        setToken(null);
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  return { userProfile, loading, token };
};

export { useProfile };